import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  select: {
    backgroundColor: theme.palette.common.white,
  },
}));
